export default __webpack_public_path__ + "static/media/500-error.a912759c.svg";